import React, { ReactNode } from "react";
import { isEqual } from "lodash";
import { getClasses } from "shared/helpers/styleHelper";

export const OptionButton = (props: OptionButtonProps) => {
  const { content, onClick, value, selectedValue } = props;

  const classes = getClasses({
    "module-option-button": true,
    "is-selected": isEqual(value, selectedValue),
  });

  return (
    <div className={classes} onClick={onClick}>
      {content}
    </div>
  );
};

interface OptionButtonProps {
  content: ReactNode;
  value: any;
  selectedValue: any;
  onClick: (value: any) => void;
}
